import { render, staticRenderFns } from "./SideRight_Content.vue?vue&type=template&id=1a09a60a"
import script from "./SideRight_Content.vue?vue&type=script&lang=js"
export * from "./SideRight_Content.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports